module.exports = __webpack_public_path__ + "img/grow_2.d1b126f0.png";